module.exports = __webpack_public_path__ + "img/pen-and-rubber-inactive.964be9f7.png";